import {
  entity as auditLogEntity,
  normalizer as auditLogNormalizer,
  listNormalizer as auditLogListNormalizer,
} from './auditLog';

import {
  entity as batchSettlementsEntity,
  listNormalizer as batchSettlementsListNormalizer,
} from './batchSettlements';

import {
  entity as brandEntity,
  normalizer as brandNormalizer,
  listNormalizer as brandListNormalizer,
} from './brand';

import {
  entity as ccTerminalEntity,
  normalizer as ccTerminalNormalizer,
  listNormalizer as ccTerminalListNormalizer,
  transformer as ccTerminalTransformer,
  listTransformer as ccTerminalListTransformer,
} from './ccTerminal';

import {
  entity as customerModulesEntity,
  normalizer as customerModulesNormalizer,
  listNormalizer as customerModulesListNormalizer,
} from './customerModules';

import {
  entity as gatewayEntity,
  normalizer as gatewayNormalizer,
  listNormalizer as gatewayListNormalizer,
  transformer as gatewayTransformer,
  listTransformer as gatewayListTransformer,
} from './gateway';

import {
  entity as gatewayConfigEntity,
  normalizer as gatewayConfigNormalizer,
  listNormalizer as gatewayConfigListNormalizer,
  transformer as gatewayConfigTransformer,
  listTransformer as gatewayConfigListTransformer,
} from './gatewayConfig';

import {
  entity as integratedPaymentsEntity,
  listNormalizer as integratedPaymentsListNormalizer,
} from './integratedPayments';

import {
  entity as industriesEntity,
  listNormalizer as industriesListNormalizer,
} from './industries';

import { entity as settlementEntity, normalizer as settlementNormalizer } from './settlement';

import {
  entity as settlementTransactionsEntity,
  listNormalizer as settlementTransactionsListNormalizer,
} from './settlementTransactions';

import {
  entity as adminShopEntity,
  endpoints as adminShopEndpoints,
  listNormalizer as adminShopListNormalizer,
} from './adminShop';

import {
  entity as shopEntity,
  normalizer as shopNormalizer,
  listNormalizer as shopListNormalizer,
  transformer as shopTransformer,
  listTransformer as shopListTransformer,
} from './shop';

import { entity as staffShopEntity, listNormalizer as staffShopListNormalizer } from './staffShop';

import {
  entity as paymentTypeEntity,
  normalizer as paymentTypeNormalizer,
  listNormalizer as paymentTypeListNormalizer,
  transformer as paymentTypeTransformer,
  listTransformer as paymentTypeListTransformer,
} from './paymentType';

import {
  entity as vendorEntity,
  endpoints as vendorEndpoints,
  normalizer as vendorNormalizer,
  listNormalizer as vendorListNormalizer,
} from './vendor';

import {
  entity as vendorReturnsEntity,
  endpoints as vendorReturnsEndpoints,
  normalizer as vendorReturnsNormalizer,
  listNormalizer as vendorReturnsListNormalizer,
} from './vendorReturns';

import {
  entity as vendorReturnItemEntity,
  endpoints as vendorReturnItemEndpoints,
  normalizer as vendorReturnItemNormalizer,
  listNormalizer as vendorReturnItemListNormalizer,
} from './vendorReturnItem';

import { endpoints as vendorReturnItemTaxEndpoints } from './vendorReturnItemTax';

import { endpoints as vendorReturnResetItemTax } from './vendorReturnResetItemTax';

import {
  entity as vendorReturnItemReasonEntity,
  endpoints as vendorReturnItemReasonEndpoints,
  normalizer as vendorReturnItemReasonNormalizer,
  listNormalizer as vendorReturnItemReasonListNormalizer,
} from './vendorReturnItemReason';

import { endpoints as vendorNumberEndpoints } from './vendorNumber';

import {
  entity as terminalEntity,
  normalizer as terminalNormalizer,
  listNormalizer as terminalListNormalizer,
  transformer as terminalTransformer,
  listTransformer as terminalListTransformer,
} from './terminal';

import {
  entity as staffEcomLanguageEntity,
  listNormalizer as staffEcomLanguageListNormalizer,
} from './staffEcomLanguage';

export const entities = {
  auditLog: auditLogEntity,
  batchSettlements: batchSettlementsEntity,
  brand: brandEntity,
  customerModules: customerModulesEntity,
  ccTerminal: ccTerminalEntity,
  ecomConfirmation: 'ecomConfirmation',
  ecomIntegration: 'ecomIntegration',
  gateway: gatewayEntity,
  gatewayConfig: gatewayConfigEntity,
  industries: industriesEntity,
  integratedPayments: integratedPaymentsEntity,
  paymentTransactionFilters: 'paymentTransactionFilters',
  paymentType: paymentTypeEntity,
  settlement: settlementEntity,
  settlementTransactions: settlementTransactionsEntity,
  adminShop: adminShopEntity,
  shop: shopEntity,
  staffEcomLanguage: staffEcomLanguageEntity,
  staffShop: staffShopEntity,
  shopDetails: 'shopDetails',
  taxSettings: 'taxSettings',
  vendor: vendorEntity,
  vendorReturns: vendorReturnsEntity,
  vendorReturnItem: vendorReturnItemEntity,
  vendorReturnItemReason: vendorReturnItemReasonEntity,
  terminal: terminalEntity,
};

export const endpoints = {
  adminShop: adminShopEndpoints,
  vendor: vendorEndpoints,
  vendorReturns: vendorReturnsEndpoints,
  vendorReturnItem: vendorReturnItemEndpoints,
  vendorReturnItemTax: vendorReturnItemTaxEndpoints,
  vendorReturnResetItemTax,
  vendorReturnItemReason: vendorReturnItemReasonEndpoints,
  vendorNumber: vendorNumberEndpoints,
};

export const normalizer = {
  auditLog: auditLogNormalizer,
  brand: brandNormalizer,
  customerModules: customerModulesNormalizer,
  ccTerminal: ccTerminalNormalizer,
  gateway: gatewayNormalizer,
  gatewayConfig: gatewayConfigNormalizer,
  paymentType: paymentTypeNormalizer,
  settlement: settlementNormalizer,
  shop: shopNormalizer,
  vendor: vendorNormalizer,
  vendorReturns: vendorReturnsNormalizer,
  vendorReturnItem: vendorReturnItemNormalizer,
  vendorReturnItemReason: vendorReturnItemReasonNormalizer,
  terminal: terminalNormalizer,
};

export const listNormalizer = {
  auditLog: auditLogListNormalizer,
  batchSettlements: batchSettlementsListNormalizer,
  brand: brandListNormalizer,
  customerModules: customerModulesListNormalizer,
  ccTerminal: ccTerminalListNormalizer,
  gateway: gatewayListNormalizer,
  gatewayConfig: gatewayConfigListNormalizer,
  industries: industriesListNormalizer,
  integratedPayments: integratedPaymentsListNormalizer,
  paymentType: paymentTypeListNormalizer,
  settlementTransactions: settlementTransactionsListNormalizer,
  adminShop: adminShopListNormalizer,
  shop: shopListNormalizer,
  staffEcomLanguage: staffEcomLanguageListNormalizer,
  staffShop: staffShopListNormalizer,
  vendor: vendorListNormalizer,
  vendorReturns: vendorReturnsListNormalizer,
  vendorReturnItem: vendorReturnItemListNormalizer,
  vendorReturnItemReason: vendorReturnItemReasonListNormalizer,
  terminal: terminalListNormalizer,
};

export const transformer = {
  ccTerminal: ccTerminalTransformer,
  gateway: gatewayTransformer,
  gatewayConfig: gatewayConfigTransformer,
  paymentType: paymentTypeTransformer,
  shop: shopTransformer,
  terminal: terminalTransformer,
};

export const listTransformer = {
  ccTerminal: ccTerminalListTransformer,
  gateway: gatewayListTransformer,
  gatewayConfig: gatewayConfigListTransformer,
  paymentType: paymentTypeListTransformer,
  shop: shopListTransformer,
  terminal: terminalListTransformer,
};
